module.exports = __webpack_public_path__ + "static/media/tetris.70538686.jpg";